// The default number of guillotine cuts needed for one material sheet, for the three "cut to size" checkboxes in
// the guillotine section. It is only the DEFAULT -- the user can still edit the field. Version-2 (Manufacturing
// Cost Calculator) only.
//
// Each "cutting to size" step guillotines a bigger sheet down into a smaller one:
//   - Pre-print cutting to size: the material sheet cut into printing sheets.
//   - Pre-die-cut cutting to size: the printing sheet cut into die-cutting sheets.
// The count is the number of FOLD STEPS -- single-axis divisions by 2, 3 or 5 -- between the two sheets. The
// backend computes it with the folding service and surfaces one per step on sheet_dimension_annotations (already
// 0 on a bobbin, and absent when the two sheets are not fold-related). Where no fold-step count is surfaced (the
// sheets are not fold-related, or a flow that does not compute one) the legacy grid-cut count is the fallback.
// Squaring (trimming the sheet's four edges straight) is a flat 4 cuts.

// How many smaller sheets fit along one edge of the bigger sheet (floored) -- the fallback grid-cut basis. Zero
// when either size is missing or non-positive, so a missing dimension contributes no cuts rather than
// NaN/Infinity.
const sliceCount = (biggerMm, smallerMm) => {
  if (!(biggerMm > 0) || !(smallerMm > 0)) {
    return 0;
  }
  return Math.floor(biggerMm / smallerMm);
};

// Internal cuts to divide a sheet into countX-wide by countY-tall pieces. Never negative (a single
// piece along an axis needs no cut there).
const gridCuts = (countX, countY) => Math.max(0, countX - 1) + Math.max(0, countY - 1);

// The cuts one "cutting to size" step contributes: the backend fold-step count when it surfaced one (the number
// of 2/3/5 guillotine folds from the bigger sheet down to the smaller, already 0 on a bobbin), otherwise the
// legacy grid-cut count derived from the two sheet sizes.
const cuttingToSizeCount = (foldSteps, biggerSheet, smallerSheet) => {
  if (foldSteps !== null && foldSteps !== undefined) {
    return foldSteps;
  }
  if (!biggerSheet || !smallerSheet) {
    return 0;
  }
  return gridCuts(
    sliceCount(biggerSheet.width, smallerSheet.width),
    sliceCount(biggerSheet.height, smallerSheet.height)
  );
};

export function guillotineCutCountDefault(options, values) {
  const annotations = (options && options.sheet_dimension_annotations) || {};
  const material = annotations.material_sheet;
  const printing = annotations.printing_layout;
  const dieCutting = annotations.die_cutting_layout;
  const checkboxes = values || {};

  let cutCount = 0;

  if (checkboxes.pre_print_cutting_to_size === true) {
    cutCount += cuttingToSizeCount(annotations.pre_print_cutting_fold_steps, material, printing);
  }

  if (checkboxes.pre_die_cut_cutting_to_size === true) {
    cutCount += cuttingToSizeCount(annotations.pre_die_cut_cutting_fold_steps, printing, dieCutting);
  }

  if (checkboxes.squaring === true) {
    cutCount += 4;
  }

  return cutCount;
}
